import React, { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { IContentPaneProps } from "./OutageReconciliation.types";
import SharedButtonStyles from "../../../shared/styled-components/buttons";
import FormStyles from "../../form/Form.styles";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../state-management/root-reducer";
import { updateAdminOutage } from "../../../state-management/slices/outages/outages.thunk";
import { ECompletedReasons } from "../../../shared/enums/outage.enums";
import { BaseMapService } from "../../map/BaseMap.service";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

const REJECT_PANE: React.FC<IContentPaneProps> = (props: IContentPaneProps) => {
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();
  const { handleClose, selectedOutage } = props;

  // Local State
  const [radioGroupValue, setRadioGroupValue] = useState<ECompletedReasons>(
    ECompletedReasons.NON_CE
  );

  // Services
  const baseMapService: BaseMapService = BaseMapService.getInstance(
    dispatch,
    sendDataToGTM
  );

  return (
    <FormStyles.FormContainer
      className="form-container"
      data-testid="reject-outage-form"
    >
      <Form
        id="RejectOutageForm"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          if (selectedOutage?.outageId) {
            dispatch(
              updateAdminOutage(
                selectedOutage,
                baseMapService,
                sendDataToGTM,
                undefined,
                undefined,
                radioGroupValue
              )
            );
          }
        }}
      >
        <FormStyles.FormLabel className="form-label radio-heading">
          Select a rejection reason
        </FormStyles.FormLabel>
        <FormStyles.FormGroup className="form-group">
          <FormStyles.FormLabel className="form-label" htmlFor="NonCERadio">
            <input
              id="NonCERadio"
              name="streetlight-type-group"
              type="radio"
              value={ECompletedReasons.NON_CE}
              checked={radioGroupValue === ECompletedReasons.NON_CE}
              onChange={(event) => {
                const { value } = event.target;
                setRadioGroupValue(value as ECompletedReasons);
              }}
            />
            <span>Non CE Streetlight</span>
          </FormStyles.FormLabel>
          <FormStyles.FormLabel className="form-label" htmlFor="NonLightRadio">
            <input
              id="NonLightRadio"
              name="streetlight-type-group"
              type="radio"
              value={ECompletedReasons.DOES_NOT_EXIST}
              checked={radioGroupValue === ECompletedReasons.DOES_NOT_EXIST}
              onChange={(event) => {
                const { value } = event.target;
                setRadioGroupValue(value as ECompletedReasons);
              }}
            />
            <span>Streetlight Does Not Exist</span>
          </FormStyles.FormLabel>
        </FormStyles.FormGroup>
        <FormStyles.FormSubmitContainer className="form-submit-container">
          <Container fluid>
            <Row>
              <Col>
                <SharedButtonStyles.BlueSecondaryButton
                  className="blue-secondary-button block"
                  onClick={handleClose}
                >
                  Cancel
                </SharedButtonStyles.BlueSecondaryButton>
              </Col>
              <Col>
                <SharedButtonStyles.RedPrimaryButton
                  type="submit"
                  className="red-primary-button block"
                >
                  Reject
                </SharedButtonStyles.RedPrimaryButton>
              </Col>
            </Row>
          </Container>
        </FormStyles.FormSubmitContainer>
      </Form>
    </FormStyles.FormContainer>
  );
};

export default REJECT_PANE;
